import * as React from "react"

import { Link, useRouter } from "@tanstack/react-router"

/**
 * @summary Displays either a Link or regular `a` component.
 *
 * It's preferable to use `Link`, but it's not always possible, since this
 * component can also be displayed outside of the Router. This component
 * displays a regular `a` link, if that's the case.
 */
export function LinkToHomepage({
  children,
  ...props
}: {
  children: React.ReactNode
}) {
  const router = useRouter({ warn: false })

  if (router) {
    return (
      <Link to="/" {...props}>
        {children}
      </Link>
    )
  } else {
    return (
      <a href="/" {...props}>
        {children}
      </a>
    )
  }
}
